import React from "react";
import styles from "./TwoToneHeading.module.css";
import clsx from "clsx";

interface TwoToneHeadingProps {
  primaryText: string;
  secondaryText: string;
  textSize?: TwoToneHeadingTextSize;
  textAlign?: TwoToneHeadingTextAlign;
  isOneLine?: boolean;
  isGoldColor?: boolean;
}

export enum TwoToneHeadingTextSize {
  heading1 = "heading01",
  heading2 = "heading02",
  heading3 = "heading03",
  heading4 = "heading04",
}

export enum TwoToneHeadingTextAlign {
  center = "center",
  left = "left",
  right = "right",
}

const TwoToneHeading: React.FC<TwoToneHeadingProps> = ({
  primaryText,
  secondaryText,
  textSize = TwoToneHeadingTextSize.heading1,
  textAlign = TwoToneHeadingTextAlign.center,
  isOneLine = false,
  isGoldColor = false,
}) => {
  const textAlignStyle = (alignStyle: TwoToneHeadingTextAlign) => {
    switch (alignStyle) {
      case TwoToneHeadingTextAlign.left:
        return styles["left"];
      case TwoToneHeadingTextAlign.right:
        return styles["right"];
      default:
        return styles["center"];
    }
  };

  return (
    <h1
      className={clsx(
        styles["two-tone-heading"],
        textSize,
        textAlignStyle(textAlign),
        isOneLine && styles["one-container"]
      )}
    >
      <span>{primaryText}</span>

      <span
        className={clsx(
          styles["secondary-text"],
          isOneLine && styles["one-container-secondary-text"],
          isGoldColor && styles["gold-color"]
        )}
      >
        {secondaryText}
      </span>
    </h1>
  );
};

export default TwoToneHeading;
